/**
 * Standalone /users route — kept for backwards compatibility with existing
 * links. The actual UI lives in UsersManagementPanel and is also embedded
 * inside the Organization page.
 */
import React from 'react';
import { Spin } from 'antd';
import AppPageLayout from './common/AppPageLayout';
import { useAdminGuard } from '../hooks/useAdminGuard';
import UsersManagementPanel from './organization/UsersManagementPanel';

const UsersPage: React.FC = () => {
  const { loading } = useAdminGuard();

  if (loading) {
    return (
      <AppPageLayout maxWidth={900}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
          <Spin size="large" />
        </div>
      </AppPageLayout>
    );
  }

  return (
    <AppPageLayout maxWidth={900}>
      <UsersManagementPanel />
    </AppPageLayout>
  );
};

export default UsersPage;
